import { Component, OnInit, HostListener } from '@angular/core';
import { ApiService } from '../api.service';
import { UserSessionService } from '../user-session.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilitiesService } from '../utilities.service';

import { MessageService } from '../message.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    username: new FormControl(null, { validators: Validators.required }),
    password: new FormControl(null, { validators: Validators.required }),
  });
  loginFormSubmitted: boolean = false;
  waitingRes: boolean = false; 
  unauthorized: boolean = false;
  unauthorizedSchedule: boolean = false;
  redirectUrl: string = ''; 


  constructor(public api: ApiService,
              public router: Router,
              public route: ActivatedRoute,
              public utils: UtilitiesService,
              public message: MessageService,
              public userSession: UserSessionService) {}

  ngOnInit() {
    this.redirectUrl = this.route.snapshot.queryParams['redirectUrl'] || '';

    if (this.userSession.getUserId()) { this.router.navigateByUrl(this.redirectUrl); }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(event.keyCode == 13) {
      this.login();
    }
  }

  loginDone(res) {
    this.api.setAuthHeader(res['data']['id']);
    this.userSession.setSession(res['data']);
    this.router.navigateByUrl(this.redirectUrl);
  }

  logginIn = false;
  login() {
    if (this.logginIn) return;

    this.loginFormSubmitted = true;
    this.unauthorized = false;
    this.unauthorizedSchedule = false;

    if (!this.loginForm.valid) return;

    let data = this.loginForm.getRawValue();
    this.waitingRes = true;

    this.logginIn = true;
    this.api.login(data.username, data.password).subscribe(res => {
      if (res.hasOwnProperty('success') && res['success']) {
        
        if (res.data.hasOwnProperty('utilizador_balcao') && res.data.utilizador_balcao === '1') {

          let resLogin = res;
          this.loginDone(resLogin);
        } else {
          this.loginDone(res);
        }

        this.message.sendMessage({ dest: 'BREADCRUMB_COMP', cmd: 'LOGIN_DONE' });

        // REGISTO ACTIVIDADES API CALL
        let descricao = 'Login efectuado.';
        this.api.saveRegistoActividade(null, null, null, null, descricao).subscribe(res => {}, err => { });

      } else {
        if (res.hasOwnProperty('status') && res.status === 'SCHEDULE_UNAUTHORIZED') {
          this.unauthorizedSchedule = true;
        } else {
          this.unauthorized = true;
        }
      }

      this.waitingRes = false;
      this.logginIn = false;
    }, err => {
      // Present login error message
      this.clear();
      this.waitingRes = false;
      this.logginIn = false;
    });
  }

  clear() {
    this.loginForm.reset();
    this.unauthorized = false;
    this.unauthorizedSchedule = false;
    this.loginFormSubmitted = false;
  }
}
